import { createFileRoute } from '@tanstack/react-router';
import { ScanResultPage } from '@pages/scan-result';

export const Route = createFileRoute('/result')({
  component: ScanResultPage,
});
